import { useEffect, useMemo, useState, useCallback } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import useFetchWellness from "./useFetchWellness";
import BenefitSetupSidebar from "./BenefitSetupSidebar";
import { MainBody, PageTitle } from "components/core";
import { BenefitSetupWrapper } from "./styles";
import BenefitSetupDetail from "./BenefitSetupDetail";
import { SideNav } from "components";

function BenefitSetup() {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const [gmcGradeCodes, setGmcGradeCodes] = useState();
  const [completedProducts, setCompletedProducts] = useState(new Set());
  const { getSelectedWellness, getLocalBenefits, getGmcGradeCodes } =
    useFetchWellness();
  const benefitsFromStore = getSelectedWellness();
  const benefits = getLocalBenefits();

  const selectedBenefit = useMemo(() => {
    return searchParams.get("benefit");
  }, [searchParams]);

  const onBenefitClick = (_, id) => {
    // Allow navigation to any product - remove sequential restrictions
    setSearchParams({
      benefit: id,
    });
  };

  const handleProductCompletion = useCallback((productId) => {
    setCompletedProducts(prev => new Set([...prev, productId]));
    
    // Stay on current product after saving - removed auto-navigation
    // User can manually navigate to other products if needed
  }, []);

  useEffect(() => {
    if (!searchParams.size && benefitsFromStore.length > 0) {
      setSearchParams({
        benefit: benefitsFromStore[0],
      });
    }
  }, [benefitsFromStore, searchParams.size, setSearchParams]);

  useEffect(() => {
    (async function () {
      const data = await getGmcGradeCodes();
      setGmcGradeCodes(data);
    })();
  }, []); // Only run once on mount

  const isOldFlow = useMemo(() => {
    if (location?.pathname.includes("v1")) {
      return false;
    }
    return true;
  }, [location]);

  return (
    <>
      {isOldFlow && <SideNav></SideNav>}
      {isOldFlow ? (
        <MainBody>
          <PageTitle title="Health & Wellness Benefits" />
          <BenefitSetupWrapper>
            <BenefitSetupSidebar
              selectedBenefits={benefitsFromStore}
              selectedBenefit={selectedBenefit}
              onBenefitClick={onBenefitClick}
              benefits={benefits}
              completedProducts={completedProducts}
            />
            <BenefitSetupDetail
              gmcGradeCodes={gmcGradeCodes}
              selectedBenefit={selectedBenefit}
              onProductCompletion={handleProductCompletion}
              completedProducts={completedProducts}
              totalProducts={benefitsFromStore.length}
            />
          </BenefitSetupWrapper>
        </MainBody>
      ) : (
        <BenefitSetupWrapper>
          <BenefitSetupSidebar
            selectedBenefits={benefitsFromStore}
            selectedBenefit={selectedBenefit}
            onBenefitClick={onBenefitClick}
            benefits={benefits}
            completedProducts={completedProducts}
          />
          <BenefitSetupDetail 
            gmcGradeCodes={gmcGradeCodes} 
            selectedBenefit={selectedBenefit}
            onProductCompletion={handleProductCompletion}
            completedProducts={completedProducts}
            totalProducts={benefitsFromStore.length}
          />
        </BenefitSetupWrapper>
      )}
    </>
  );
}

export default BenefitSetup;
